import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { formatApiError } from "@/lib/api";
import { fmtFecha } from "@/lib/format";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export default function JustificarIncidenciaDialog({ item, onClose, onSuccess }) {
  const [motivos, setMotivos] = useState([]);
  const [motivoId, setMotivoId] = useState("");
  const [motivoOtro, setMotivoOtro] = useState("");
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (!item) return;
    api.get("/motivos-incidencia").then(({ data }) => setMotivos(data)).catch(() => {});
  }, [item]);

  const seleccionado = motivos.find((m) => String(m.id) === motivoId);
  const requiereOtro = seleccionado?.es_otros;

  const enviar = async () => {
    if (!motivoId) {
      toast.error("Selecciona un motivo");
      return;
    }
    if (requiereOtro && motivoOtro.trim().length < 3) {
      toast.error("Especifica el motivo en «Otros»");
      return;
    }
    setEnviando(true);
    try {
      await api.post("/solicitudes/justificar-incidencia", {
        solicitud_id: item.id,
        motivo_id: Number(motivoId),
        motivo_otro: motivoOtro.trim(),
      });
      toast.success("Justificación enviada al encargado");
      onSuccess?.();
      onClose();
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setEnviando(false);
    }
  };

  return (
    <Dialog open={!!item} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="justificar-incidencia-dialog">
        <DialogHeader>
          <DialogTitle>Justificar incidencia</DialogTitle>
        </DialogHeader>
        {item && (
          <div className="space-y-3 text-sm">
            <p className="text-zinc-600">
              Periodo: <strong>{fmtFecha(item.fecha_inicio)} — {fmtFecha(item.fecha_fin)}</strong>
            </p>
            <div className="space-y-1.5">
              <Label>Motivo</Label>
              <select
                className="h-9 w-full rounded-md border border-zinc-200 px-2"
                value={motivoId}
                onChange={(e) => setMotivoId(e.target.value)}
              >
                <option value="">Selecciona…</option>
                {motivos.map((m) => (
                  <option key={m.id} value={m.id}>{m.nombre}</option>
                ))}
              </select>
            </div>
            {requiereOtro && (
              <div className="space-y-1.5">
                <Label>Especifica el motivo</Label>
                <Textarea value={motivoOtro} onChange={(e) => setMotivoOtro(e.target.value)} rows={3} />
              </div>
            )}
          </div>
        )}
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Cancelar</Button>
          <Button onClick={enviar} disabled={enviando} className="bg-rose-600 hover:bg-rose-700">
            {enviando ? "Enviando…" : "Solicitar justificación"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
